import { Injectable, inject } from '@angular/core';
import { NativeService } from '@shared/services/native.service';

export interface GpGamesPlayer {
  playerId: string;
  displayName: string;
  iconImageUri?: string;
  hiResImageUri?: string;
}

export interface GpGamesNativePlayerResponse extends GpGamesPlayer {
  error: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class GooglePlayGamesService {
  private readonly nativeService = inject(NativeService);

  async fetchPlayer(): Promise<GpGamesPlayer> {
    const response = (await this.nativeService.communicationHandler.sendAndAwait(
      'gpLogin',
      {},
      null
    )) as GpGamesNativePlayerResponse;
    if (response.error) {
      throw 'Unable to complete the native Google Play Games login';
    }
    return response;
  }
}
